import { LocalStorageKey } from "@/modules/local-storage/constants";

export type StripeCheckoutSessionRecord = {
  id: string;
  savedAtMs: number;
};

const TTL_MS = 24 * 60 * 60 * 1000; // 24 hours

export const readStripeLastCheckoutSession = (): StripeCheckoutSessionRecord | null => {
  try {
    const raw = localStorage.getItem(LocalStorageKey.StripeLastCheckoutSession);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as StripeCheckoutSessionRecord;
    if (!parsed?.id || typeof parsed.savedAtMs !== "number") return null;
    if (Date.now() - parsed.savedAtMs > TTL_MS) {
      localStorage.removeItem(LocalStorageKey.StripeLastCheckoutSession);
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
};

export const writeStripeLastCheckoutSession = (id: string): void => {
  try {
    const record: StripeCheckoutSessionRecord = { id, savedAtMs: Date.now() };
    localStorage.setItem(LocalStorageKey.StripeLastCheckoutSession, JSON.stringify(record));
  } catch {
    // noop
  }
};

export const clearStripeLastCheckoutSession = (): void => {
  try {
    localStorage.removeItem(LocalStorageKey.StripeLastCheckoutSession);
  } catch {
    // noop
  }
};
